import { staticSettings } from "@montana/helpers/static-settings.helper";
import { IMontanaFacet, IFilterRequest } from "@montana/models/generated/cms.interface";

import { createServiceFunction } from "./http";
import { CUSTOMER_MODE } from "@montana/constants/customer-mode";

/**
 * Fetch filter data.
 * Predefined filter setup made by the editor is handled by BE through the filterId, which is provided on the filterpage - luxurious magic hidden from FE.
 * @param filterId ID provided by BE linking the request to editorial predefined filter settings
 * @param filterLanguage
 * @param selectedFacets
 * @param initialLoad if true fetch results up to page index, if false fetch only the requested page.
 * @param pageIndex
 */
export const fetchFilterData = createServiceFunction((filterId: number, filterLanguage: string, searchQuery = '', selectedFacets: IMontanaFacet[] = [], sortBy = '', initialLoad = true, pageIndex = 0, customerMode: string) => {
    const url =
        customerMode === CUSTOMER_MODE.PRIVATE || customerMode === CUSTOMER_MODE.B2B ? `${staticSettings.apiUrl}/api/productlist/private` :
        customerMode === CUSTOMER_MODE.PROFESSIONAL ? `${staticSettings.apiUrl}/api/productlist/professional` :
        "";

    const requestBody: IFilterRequest = {
        filterId,
        filterLanguage,
        searchQuery,
        initialLoad: !!initialLoad,
        pageIndex,
        sortBy,
        selectedFacets,
    };

    return f => f(`${url}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody)
    });
});
